import { Star, X } from "lucide-react";
import { useStore, prioritiesForDate, toggleTaskPriority, findCategory } from "@/lib/store";

export default function PrioritiesCard({ dateISO }) {
  useStore(); // subscribe
  const items = prioritiesForDate(dateISO);
  const slots = [0, 1, 2];
  return (
    <div className="tl-paper p-5" data-testid="priorities-card">
      <div className="flex items-center justify-between">
        <div className="tl-label flex items-center gap-2">
          <Star size={12} strokeWidth={1.5} className="text-[#D4A94A]" fill="#D4A94A" />
          Le 3 priorità di oggi
        </div>
        <span className="text-[11px] text-[#6A7368] tabular-nums">{items.length}/3</span>
      </div>
      <div className="mt-3 flex flex-col gap-2">
        {slots.map((i) => {
          const t = items[i];
          if (!t) {
            return (
              <div key={i} className="flex items-center gap-3 text-sm text-[#6A7368]" data-testid={`priority-slot-empty-${i}`}>
                <span className="w-6 h-6 rounded-full border border-dashed border-[#E4E7E1] flex items-center justify-center text-[11px] text-[#6A7368]">{i + 1}</span>
                <span className="italic">Tocca la stella su un'attività per aggiungerla qui.</span>
              </div>
            );
          }
          const cat = findCategory(t.categoryId);
          return (
            <div key={t.id} className="flex items-center gap-3" data-testid={`priority-slot-${i}`}>
              <span className="w-6 h-6 rounded-full bg-[#F3F5F0] flex items-center justify-center text-[11px] font-medium text-[#3B443D]">{i + 1}</span>
              <div className="flex-1 min-w-0">
                <div className={`text-sm ${t.done ? "tl-strike" : "text-[#3B443D]"} truncate`}>{t.title}</div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="tl-chip" style={{ background: cat.color + "26", color: "#58635B" }}>
                    <span className="tl-chip-dot" style={{ background: cat.color }} />
                    {cat.name}
                  </span>
                  {t.time && <span className="text-[11px] text-[#6A7368]">{t.time}</span>}
                </div>
              </div>
              <button
                type="button"
                onClick={() => toggleTaskPriority(t.id)}
                className="text-[#6A7368] hover:text-[#C48B97]"
                data-testid={`priority-remove-${t.id}`}
                aria-label="Rimuovi dalla priorità"
              >
                <X size={14} strokeWidth={1.5} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
